module.exports = __webpack_public_path__ + "static/img/step-042.9ecaec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-042.png
// module id = 6gxZ
// module chunks = 1